exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._37JPKGgaaRThiowfyaxS5c{font-size:17px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\";cursor:pointer;overflow:hidden;text-overflow:ellipsis}html[dir] ._37JPKGgaaRThiowfyaxS5c{background:transparent;border-width:0}html[dir=ltr] ._37JPKGgaaRThiowfyaxS5c{text-align:left}html[dir=rtl] ._37JPKGgaaRThiowfyaxS5c{text-align:right}", ""]);

// exports
exports.locals = {
	"groupName": "_37JPKGgaaRThiowfyaxS5c"
};